import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PWA : enregistrement du service worker
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Notifie l'utilisateur qu'une nouvelle version est disponible
    const shouldReload = window.confirm(
      '🎉 Une nouvelle version de Bulléthèque est disponible ! Recharger ?'
    );
    if (shouldReload && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  },
});
